<div class="Padre">
    <banner-app [Fixtop]="''" [retroSelected]=false [infoDueno]=true  [showPromo]="true"></banner-app>

    <div style="background-color: #DFEAFF;">
        <br>
        <div class="container">
            <div class="row contenido">
                <div class="col">
                    <div class="textoArriba">
                        <br><br><br><br>
                        <div>
                            <h3 class="texto2" style="padding-bottom: 12px;">En este momento, no estamos<br>preparados para asegurar tu moto.</h3>
                            <h5 class="texto1">Seguimos trabajando para ofrecerte más opciones.
                            </h5>
                        </div>
                        <br>
                        <img src="./assets/img/motoHome_1.gif" width="150px" height="200px" loading="lazy" alt="seguro de moto precio" >
                    </div>
                    <div class="textoAbajo">
                        <br><br>
                        <img src="./assets/img/paleteroSinFondo.png" width="200px" height="199px" loading="lazy" alt="seguro de moto precio" >
                        <br><br>
                        <div>
                            <h3 class="texto2">
                                En este momento no estamos preparados<br> 
                                para asegurar tu moto. Seguimos<br>
                                trabajando para ofrecerte más opciones.
                            </h3>
                        </div>
                    </div>
                    <br><br>
                    <div class="container tamanioBoton">
                        <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit"
                            (click)="volverInicio()">
                            Volver al inicio
                        </button>
                    </div>
                    
                </div>
                
            </div>
        </div>

        <br><br><br><br>
        <app-footer-app class="footer-fixed" />

    </div>
</div>